import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

interface RecaptchaStyles {
  recaptchaContainer: Styles
}

export const useStyles = createUseStyles<RecaptchaStyles>((theme) => {
  return {
    recaptchaContainer: {
      position: 'relative',
      marginTop: theme.calcUnit(theme.spacing.s16 + theme.spacing.s3),
    },

    '@global': {
      'body.is-accounts-page .grecaptcha-badge': {
        position: 'absolute !important',
        zIndex: theme.zIndex.highestLevel,
      },
    },
  }
})
